<template>
  <el-form
    ref="ruleForm"
    v-loading="loading"
    :model="form"
    :rules="rules"
    label-position="top"
    :validate-on-rule-change="false"
  >
    <el-form-item
      label="Days to Fingerprint expiration"
      prop="expiration_days"
      :error="errors.expiration_days"
    >
      <el-input-number
        v-model="form.expiration_days"
        :min="1"
        :max="200"
        :step="1"
        :controls="false"
        @update:modelValue="update"
      />
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import { computed, ref, defineComponent, Ref } from 'vue'

import { useRetargetingListsStore } from '@/apps/traforama/store/retargetingLists'
import { ElMessage } from 'element-plus'
import { safeSubmitProcessing } from '@/utils/helpers'
import useValidation from '@/hooks/useValidation'
import { CommonValidationErrorsKey } from '@/api/types'
import { IRetargetingListPayload } from '@/apps/traforama/interfaces/retargetingLists'
export default defineComponent({
  name: 'RetargetingListForm',
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  setup(props, { emit, expose }) {
    const retargetingListsStore = useRetargetingListsStore()
    const loading = ref(false)
    const ruleForm: Ref<ElForm | null> = ref(null)
    const rules = {
      expiration_days: [
        { required: true, message: 'Please fill the field', trigger: 'blur' }
      ]
    }
    const valueInDays = ref(props.modelValue)
    const form = computed(() => {
      return { expiration_days: props.modelValue }
    })
    const { provideValidation, setValidationErrors } = useValidation(
      CommonValidationErrorsKey
    )
    const errors = provideValidation()

    const save = () => {
      ruleForm.value?.validate(async (valid: boolean) => {
        if (valid) {
          const payload = {
            id: props.id,
            expiration_days: valueInDays.value
          } as IRetargetingListPayload
          errors.value = {}
          await safeSubmitProcessing(
            loading,
            () => retargetingListsStore.SaveItem(payload),
            (response) => {
              ElMessage.success(
                'Retargeting list has been successfully updated.'
              )
              close()
              retargetingListsStore.FetchItems()
            },
            (err) => setValidationErrors(err, errors)
          )
        }
      })
    }

    const close = () => {
      emit('close')
    }

    expose({ save, close })

    const update = (val: number) => {
      valueInDays.value = val
    }

    return {
      form,
      errors,
      save,
      loading,
      ruleForm,
      rules,
      close,
      update
    }
  }
})
</script>

<style lang="scss" scoped></style>
